jQuery(function($){

	$('html').removeClass('no-js'); 




	// PRELOADER
	$(window).load(function() {
		$('#page_preloader').delay(700).fadeOut(700);

		function preloaderRemove() {
			$('#page_preloader').remove()
		};

		setTimeout( preloaderRemove, 3000 );
	});




	// IOS HOVER
	if ((navigator.userAgent.match(/iPhone/i)) || (navigator.userAgent.match(/iPod/i)) || (navigator.userAgent.match(/iPad/i))) {
		$('a').on("touchstart", function() {});
	};




	// PLACEHOLDER JS 
	$('[placeholder]').each(function(){
	  if ($(this).val() === '') {
		var hint = $(this).attr('placeholder');
		$(this).val(hint).addClass('hint');
	  }
	});

	$('[placeholder]').focus(function() {
	  if ($(this).val() === $(this).attr('placeholder')) {
		$(this).val('').removeClass('hint');
	  }
	}).blur(function() {
	  if ($(this).val() === '') {
		$(this).val($(this).attr('placeholder')).addClass('hint');
	  }
	});




	// FORM STYLES   
	$('.address_table form, .customer_address form').addClass('form-horizontal');




	// CUSTOM SELECTS 
	$('.header_currency select, #navigation select').styler();
	$('.jq-selectbox__trigger').append('<i class="fa fa-caret-down"></i>');




	// MEGAMENU ACTIVE HOME LINK
	$('.megamenu_desktop li a').each(function() {
		var winLoc = String(window.location);

		if ( $(this).attr('href') == '/' && winLoc.substring(0, winLoc.length - 1) == window.location.origin ) {
			$(this).addClass('ajax_link__active');
		};
	});




	// STICK MENU
	$(window).on('load', function() {
		$('#header_stick').tmStickUp();
	});




	// BACK TO TOP BUTTON 
	$(document).ready(function(){
		$(document.body).append('<a id="back_top" href="#"></a>');
		$('#back_top').hide();

		$(window).scroll(function(){
			if ( $(this).scrollTop() > 300 ) {
				$('#back_top').fadeIn("slow");
			}
			else {
				$('#back_top').fadeOut("slow");
			};
		});

		$('#back_top').on('click', function(e) {
			e.preventDefault();
			$('html, body').animate({scrollTop : 0},800);
			$('#back_top').fadeOut("slow").stop();
		});
	});




	// PRODUCT QUANTITY FORM MINI, USED ON:
	// 1. PRODUCT PAGE
	// 2. PRODUCT QUICK VIEW
	// 3. CART PAGE
	$(document).on("focusout",".quantity_input",function(){var t=$(this).val();$(this).val(isNaN(parseFloat(t))&&!isFinite(t)||0==parseInt(t)||""==t?1:parseInt(t)<0?parseInt(t)-2*parseInt(t):parseInt(t))}),$(document).on("click",".quantity_up",function(){var t=$(this).parent().find(".quantity_input");t.val(!isNaN(parseFloat(t.val()))&&isFinite(t.val())?parseInt(t.val())+1:1)}),$(document).on("click",".quantity_down",function(){var t=$(this).parent().find(".quantity_input");t.val(!isNaN(parseFloat(t.val()))&&isFinite(t.val())&&t.val()>1?parseInt(t.val())-1:1)});




	// LOGO SPLIT WORDS
	function makeWrapElem(e,n){return $('<span class="wrap-'+e+'">'+n.join(" ")+" </span>")}$.fn.splitWords=function(e){return this.each(function(){var n,t,a=$(this),p=a.text().split(/\s/);n="number"==typeof e?e>0?e:p.length+e:Math.floor(p.length/2),t=p.splice(0,n),a.empty().append(makeWrapElem(1,t)).append(makeWrapElem(2,p))})};

	$('#logo_main b').splitWords(2);




/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////




	// AJAX PRELOADER
	$.fn.ajaxPreloader = function(e) {
		var $this = $(this);

		if ( e == 'ON' ) {
			$this.removeClass('loader_off loader_hidden').addClass('loader_on');
		}
		else if ( e == 'OFF' ) {
			$this.removeClass('loader_on').addClass('loader_off');
			setTimeout( function() {
				$this.addClass('loader_hidden')
			}, 5000 );
		};
	};




	// AJAX CONTENT
	$.fn.ajaxContent = function(e) {
		if ( e == 'ON' ) {
			this.removeClass('content_off').addClass('content_on');
		}
		else if ( e == 'OFF' ) {
			this.removeClass('content_on').addClass('content_off');
		};
	};




	
		// HOMEPAGE VIDEO
		homepageVideo = function() {
			if ( $('#bg_video').length ) {

				if ( device.desktop() ) {
					$('#bg_video').YTPlayer();

					$.mbYTPlayer.controls = {
						play: "&#xf04b;",
						pause: "&#xf04c;",
						mute: "&#xf028;",
						unmute: "&#xf026;",
						onlyYT: "O",
						showSite: "R",
						ytLogo: "Y"
					};

					$('#bg_video').on("YTPReady", function() {
						$('#bg_video__content').removeClass('off');
						$('#bg_video__overlay').addClass('off');
						$('#controlBar_bg_video').addClass('off');

						$('<span class="player_close ytpicon">&#xf00d;</span>').insertBefore('.mb_YTPUrl').on('click', function() {
							$('#bg_video__content').removeClass('off');
							$('#controlBar_bg_video').addClass('off');
							$('#bg_video').YTPPlay().YTPMute();
						});

						$('.mb_YTPUrl').on('click', function() {
							$('#bg_video').YTPPause();
						});

						$('#bg_video__btn').on('click', function(e) {
							$('#bg_video__content').addClass('off content_hidden');
							$('#controlBar_bg_video').removeClass('off');
							$('#bg_video').YTPPlay().YTPUnmute();
							e.stopPropagation();
						});

						$(document).on('click', '.content_hidden', function(e) {
							$('#controlBar_bg_video').addClass('off');
							$('#bg_video__content').removeClass('off content_hidden');
							$('#bg_video').YTPPlay().YTPMute();
							e.stopPropagation();
						});
					});
				}
				else {
					$('#bg_video__content').removeClass('off');
					$('#bg_video__btn, #bg_video__overlay').remove();
				};

			};
		};

		$(window).load(function() {
			homepageVideo();
		});
	


  


	
		// HOMEPAGE PRODUCTS IMAGE CHANGE
		imgChange = function (){
			if ( $('.product_img').length && device.desktop() ) {
				$(document).on({
					mouseenter: function(){
						$(this).find(".img__2").stop().animate({"opacity": 1});
					},
					mouseleave: function(){
						$(this).find(".img__2").stop().animate({"opacity": 0});
					}
				}, '.product_img');
			};
		};

		$(window).load( imgChange );
	


	
		// HOMEPAGE BACKGROUND PARALLAX EFFECT
		parallaxBG = function() {
			if ( device.desktop() ) {
				if ( $("#parallax_1").length ) {
					// PARALLAX BLOCK #1
					$("#parallax_1").RDParallax();
				};

				if ( $("#parallax_2").length ) {
					// PARALLAX BLOCK #2
					$("#parallax_2").RDParallax();
				};
			};
		};

		$(window).load(function() {
			parallaxBG();
		});
	



	
	




	




	
		// CONTACTS PAGE GOOGLE MAP
		$(window).on('load', function() {
			if ( $('#google_map').length ) {
				initialize();
			};
		});
	




	// AJAX PAGES ///////////////////////////////////////////////////////////////////////////////////////////////////

	AJAXpages = function (){
		$(document).on('click', '.ajax_link', function(e) {

			var linkURL = $(this).attr('href');

			// scrollbar toggle
			if ( $(document).height() > $(window).height() ) {
				$('body').css({ 'overflow-y' : 'scroll' });
			}
			else {
				$('body').css({ 'overflow-y' : 'auto' });
			};

			// removing previous active link
			$('.ajax_link').each(function() {
				$(this).removeClass('ajax_link__active');
			});

			// highlighting actual active link
			$(this).addClass('ajax_link__active');

			// highlighting actual megamenu active link
			$('.megamenu_desktop li a').each(function() {
				if ( $(this).attr('href') == linkURL ) {
					$(this).addClass('ajax_link__active');
				};
			});

			// showing preloader
			$('#content_preloader').ajaxPreloader( 'ON' );

			// hiding content
			$('#main').ajaxContent( 'OFF' );

			// loading content
			$('#main').load( linkURL + ' #main > *', function(data) {

				setTimeout( function() {
					// hiding preloader
					$('#content_preloader').ajaxPreloader( 'OFF' );

					// showing content
					$('#main').ajaxContent( 'ON' );
				}, 500 );

				// adding page title
				var newTitle = $(data).filter('title').text();
				document.title = newTitle;

				
					// showing homepage video block
					homepageVideo();
				

				
					// homepage products image change
					imgChange();
				

				
					// homepage background parallax effect
					parallaxBG();
				

				

				

				
					// contacts page google map
					if ( $('#google_map').length ) {
						initialize();
					};
				

				// account forms
				accountForms();

				// cart page actions
				cartReload( '.cart_update', 'update' );
				cartReload( '.cart_item__remove', 'remove' );
				cartReload( '#cart_clear', 'clear' );

				// product page scripts
				productPage();

				// toggling currency switcher
				currencyToggle('span.money');

				// initializing addthis buttons
				addThisInit();

			});

			// adding page address to url
			window.history.pushState( null, null, linkURL );

			e.preventDefault();
		});
	};

	$(window).load( AJAXpages );




	// AJAX SEARCH
	$(document).on('submit', '#header_search', function(e) {
		var searchQuery = $('#search-field').val().replace(/ /g, '+');
		var searchURL = window.location.origin + '/search?q=' + searchQuery;

		if ( searchQuery.length && searchQuery != $('#search-field').attr('placeholder').replace(/ /g, '+') ) {
			// showing preloader
			$('#content_preloader').ajaxPreloader( 'ON' );

			// hiding content
			$('#main').ajaxContent( 'OFF' );

			$('#main').load( searchURL + ' #main > *', function(data) {

				// hiding preloader
				$('#content_preloader').ajaxPreloader( 'OFF' );

				// showing content
				$('#main').ajaxContent( 'ON' );

				// adding page title
				var newTitle = $(data).filter('title').text();
				document.title = newTitle;

			});

			// removing previous active link
			$('.ajax_link').each(function() {
				$(this).removeClass('ajax_link__active');
			});

			// adding page address to url
			window.history.pushState( null, null, searchURL );

			e.preventDefault();
		}
		else {
			e.preventDefault();
		};
	});




	// AJAX CONTACT FORM
	$(document).on('submit', '#contact_form form', function(e) {

		// getting form data
		var contactData = $(this).serialize();

		// showing preloader
		$('#form_preloader').ajaxPreloader( 'ON' );

		// hiding content
		$('#contact_form__answer').slideUp(300);

		// sending data
		$.ajax({
			type: 'POST',
			url: '/contact',
			data: contactData,
			success: function( data, textStatus, jqXHR ) {

				// removing feedback data
				$('#contact_form__answer').empty();

				// getting feedback
				var formFeedback = $(data).find('#contact_form__answer').html();

				// inserting feedback data
				$('#contact_form__answer').prepend( formFeedback );

				setTimeout( function() {
					// hiding preloader
					$('#form_preloader').ajaxPreloader( 'OFF' );

					// showing content
					$('#contact_form__answer').slideDown(300);
				}, 500 );

			},
			error: function( data ) {

			}
		});

		e.preventDefault();

	});




	// AJAX ARTICLE COMMENT FORM
	$(document).on('submit', '#comment_form', function(e) {

		// getting form data
		var contactData = $(this).serialize();

		// showing preloader
		$('#form_preloader').ajaxPreloader( 'ON' );

		// hiding content
		$('#comment_form__answer').slideUp(300);

		// sending data
		$.ajax({
			type: 'POST',
			url: window.location.href + '/comments#comment_form',
			data: contactData,
			success: function( data, textStatus, jqXHR ) {

				// removing feedback data
				$('#comment_form__answer').empty();

				// getting feedback
				var formFeedback = $(data).find('#comment_form__answer').html();

				// inserting feedback data
				$('#comment_form__answer').prepend( formFeedback );

				setTimeout( function() {

					// hiding preloader
					$('#form_preloader').ajaxPreloader( 'OFF' );

					// showing content
					$('#comment_form__answer').slideDown(300);

					// clearing the form
					$('#comment_form').find('input, textarea').val('');

				}, 500 );

				// reloading comments list
				$('#article_comments__list').load( window.location.href + ' #article_comments__list > *' );

			},
			error: function( data ) {

			}
		});

		e.preventDefault();

	});




	// ACCOUNT FORMS
	accountForms = function() {
		// LOGIN PAGE
		if ( $('#account_page').length ) {

			if ( $('#account_register').find('.alert').length ) {
				$('#account_login, #account_reset').hide();
			}
			else if ( $('#account_reset').find('.alert').length ) {
				$('#account_reset').show();
				$('#account_register').hide();
			}
			else {
				$('#account_register, #account_reset').hide();
			};

			$('#account_reset__link').on('click', function(e) {
				e.preventDefault();

				$('#account_reset').slideDown();
			});

			$('.account_reset__cancel').on('click', function(e) {
				e.preventDefault();

				$('#account_reset').slideUp();
			});

			$('#account_register__link').on('click', function(e) {
				e.preventDefault();

				if ( $('#account_reset:visible') ) {
					$('#account_reset').slideUp();
				};

				$('#account_login').delay(0).slideUp();
				$('#account_register').delay(0).slideDown();
			});

			$('.account_register__cancel').on('click', function(e) {
				e.preventDefault();

				$('#account_register').slideUp();
				$('#account_login').slideDown();
			});

			if (window.location.hash == '#recover') { 
				$('#account_reset').show();
			};

			$('#account_register a[href*="recover"]').on('click', function() {
				$('#account_register').slideUp();
				$('#account_login').slideDown();
				$('#account_reset').slideDown();
			});
		};

		// ADDRESSES PAGE
		if ( $('#addresses_page').length ) {

			// ADDING NEW ADDRESS
			$('#address_add, #address_add__close').hide();

			$('#address_add__link').on('click', function(e) {
				e.preventDefault();

				$(this).fadeOut(300);
				$('#address_add__close').delay(300).fadeIn();
				$('#address_add').slideDown();
			});

			$('#address_add__close, #address_add__cancel').on('click', function(e) {
				e.preventDefault();

				$('#address_add__close').fadeOut(300);
				$('#address_add__link').delay(300).fadeIn();
				$('#address_add').slideUp();
			});

			// EDIT EXISTING ADDRESS
			$('.account_address__edit').hide();
			$('.account_address__item .link_close').hide();

			$('.link_edit').on('click', function(e) {
				e.preventDefault();

				var t = $(this).attr('href');

				$(t).find('.account_address__edit').slideDown();

				$(this).fadeOut(300);

				$(t).find('.link_close').delay(300).fadeIn();

				$(t).find('.link_close').on('click', function(event) {
					event.preventDefault();

					$(t).find('.account_address__edit').slideUp();

					$(this).fadeOut(300);

					$(t).find('.link_edit').delay(300).fadeIn();
				});

				$(t).find('.link_cancel').on('click', function(event) {
					event.preventDefault();

					$(t).find('.link_close').trigger('click');
				});

			});

		};
	};

	$(window).on('load', function() {
		accountForms();
	});




	// CART PAGE ACTIONS
	cartReload = function(trigger, action) {
		if ( $('#cart_content').length ) {
			$(document).on('click', trigger, function(e) {
				e.preventDefault();

				$('#cart_preloader').ajaxPreloader( 'ON' );

				if ( action == 'update' ) {
					var cartItems = {};

					$.each( $('.cart_item'), function() {
						cartItems[ $(this).attr('data-id') ] = $(this).find('.quantity_input').val();
					});

					var requestData = { updates: cartItems };
					var requestUrl = '/cart/update.js?t=' + e.timeStamp;
				}
				else if ( action == 'remove' ) {
					var lineValue = $(this).attr('title');
					var requestData = { line: lineValue, quantity: 0 };
					var requestUrl = '/cart/change.js?t=' + e.timeStamp;
				}
				else if ( action == 'clear' ) {
					var requestData = '';
					var requestUrl = '/cart/clear.js?t=' + e.timeStamp;
				};

				$.post(
					requestUrl,
					requestData,
					function(data) {
						$('#cart_items').html( data.item_count );

						if ( action == 'clear' ) {
							$('#cart_content').ajaxContent( 'OFF' );
						};

						$('#cart_content').load( '/cart?t=' + e.timeStamp + ' #cart_content > *', function() {
							currencyToggle('span.money');

							$('#cart_preloader').ajaxPreloader( 'OFF' );

							if ( action == 'clear' ) {
								$('#cart_content').ajaxContent( 'ON' );
							};
						});
					}, 'json'
				);
			});
		};
	};

	$(window).on('load', function() {
		cartReload( '.cart_update', 'update' );
		cartReload( '.cart_item__remove', 'remove' );
		cartReload( '#cart_clear', 'clear' );
	});




	// PRODUCT PAGE SCRIPTS
	productPage = function() {
		if ( $('#product_wrap').length ) {
			$('#elevatezoom_big').elevateZoom({
				gallery : "elevatezoom_gallery",
				zoomActivation: "hover",
				zoomType : "window",
				scrollZoom : true,
				zoomWindowFadeIn : 500,
				zoomLensFadeIn: 500,
				imageCrossfade: true,
				zoomWindowWidth : 370,
				zoomWindowHeight : 370,
				zoomWindowOffetx : 15,
				zoomWindowOffety : 0,
				borderSize : 1,
				borderColour : "#eae9ea"
			});

	        $(document).on('click', '.elevatezoom_big_clicker', function() {
	            $('.zoomLens').trigger('click');
	        });

			// BIG IMAGE FANCYBOX
			$('#elevatezoom_big').bind('click', function() {
				$.fancybox( $('#elevatezoom_big').data('elevateZoom').getGalleryList() );
				return false;
			});

			// THUMBS SLIDER
			$('#elevatezoom_gallery').bxSlider({
				infiniteLoop: true,
				minSlides: 1,
				maxSlides: 4,
				moveSlides: 1,
				slideWidth: 101,
				pager: false,
				prevText: '',
				nextText: ''
			});

			// GETTING PRODUCT VARIANTS
			$.getJSON( window.location.href + '.js', function( data ) {

				new Shopify.OptionSelectors( "product-select", {
					product: data,
					onVariantSelected: selectCallback,
					enableHistoryState: false 
				});

			});

		};
	};

	$(window).load(function() {
		productPage();
	});



	addThisInit = function() {
		if ( $('#addthis_toolbox').length ) {
			addthis.toolbox('#addthis_toolbox');
			addthis.layers.refresh();
		}
	};




	itemAddedModal = function(r) {
	    $('body').append('<div id="cart_added"><h4>Product added to cart</h4><div class="cart_added__row"><div class="cart_added__1" id="cart_added__img"><img src="" alt="" /></div><div class="cart_added__2"><span id="cart_added__name" class="product_name"></span><p id="cart_added__quantity">Quantity: <span></span></p><a id="cart_link" class="btn" href="#">Go to cart</a><a class="btn btn-alt" id="cart_added__close" href="#">Continue shopping</a></div></div></div>');

	    if ( r.title.length < 60 ) {
	        var productTitle = r.title;
	    }
	    else {
	        var productTitle = $.trim( r.title ).substring(0, 60) + '...';
	    };

	    $('#cart_added__name').html( productTitle );
	    $('#cart_added__quantity span').html( r.quantity );
	    $('#cart_added__close').on( 'click', function(e) {
	        e.preventDefault();

	        $('.fancybox-close').trigger('click');
	    });
		$('#cart_link').on('click', function(e) {
			$('.fancybox-close').trigger('click');

			setTimeout(function() {
				$('.header_cart a').trigger('click')
			}, 500);

			e.preventDefault();
		});

		if ( r.image ) {
		    $('#cart_added__img img').attr( 'src', r.image ).load( function() { 
		        $.fancybox.open( $('#cart_added'),
		            {
		                'openSpeed': 500,
		                'closeSpeed': 300,
		                'afterClose': function() {
		                    $('#cart_added').remove();
		                }
		            }
		        );
		    });
		}
		else {
			$('#cart_added__img').hide();
		    $.fancybox.open( $('#cart_added'),
		        {
		            'openSpeed': 500,
		            'closeSpeed': 300,
		            'afterClose': function() {
		                $('#cart_added').remove();
		            }
		        }
		    );
		};
	};




});